export default __webpack_public_path__ + "static/pendantandring-29906ec79f2145672be3f0b73d9537a1.png";